


    let toExport = {}
    

    class Rating {
        constructor() {
          
          this.lookupTable = {
            NPSToFive: {
                0: 1,
                1: 1,
                2: 1,
                3: 2,
                4: 2,
                5: 3,
                6: 3,
                7: 4,
                8: 4,
                9: 5,
                10: 5  
            },
            fiveToNPS: {
              1: 0,
              2: 4,
              3: 6,
              4: 8,
              5: 10
            }
          }
        }
      }
      
      
      
      
      
      
      function generateTextField(langPackSlug, slug) {
          return '__fbloflang__' + langPackSlug + '__' + slug
      }
      
      function getQuestionID () {
          return String(Number(new Date())) + String('q' + Math.floor(Math.random() * (1000 - 0 + 1) )) + String('q' + Math.floor(Math.random() * (1000 - 0 + 1) )) + String('q' + Math.floor(Math.random() * (1000 - 0 + 1) ))
      }
      
      
      
      toExport.createStep = function createStep(type, language, ratingType) {
      
          let toReturn = false
      
      
          switch (type) {
              case "ratingq":
                toReturn = {
                    type: "ratingq",
                    questionID: ratingType === 'nps' ? "NPSr" : (ratingType === 'star' ? 'STARr' : 'CSATr'),
                    ratingType: ratingType,
                    content: {
                        ask: generateTextField(language, ratingType === 'nps' ? "NPSQuestion" : (ratingType === 'star' ? 'starQuestion' : 'CSATQuestion')),
                        heading: false,
                        additionalText: generateTextField(language, 'chooseOne'),
                        tips: false
                    }
                }
                break;
              case "openq":
                  toReturn = {
                      type: "openq",
                      questionID: getQuestionID(),
                      content: {
                          ask: "[New open question]",
                          heading: false,
                          additionalText: false,
                          tips: false
                      },
                      allowedResponses: {
                          text: true,
                          video: false
                      },
                      showTo: {
                          ratingScale: 'all'
                      },
                      allowSkip: true,
                      videoNotesPlaceholderText: generateTextField(language, 'videoMakeNotes'),
                      textInputPlaceholderText: generateTextField(language, 'openTextAnswerPlaceholder')
                  }
                  break;
              case "multiq":
                  toReturn = {
                      type: "multiq",
                      questionID: getQuestionID(),
                      content: {
                        ask: "[New multiple choice question]",
                          heading: false,
                          additionalText: false,
                          tips: false
                      },
                      showTo: {
                          ratingScale: 'all'
                      },
                      answerOptions: [{
                        text: "Answer option 1",
                        description: "Answer option 1 description"
                      },{
                        text: "Answer option 2",
                        description: "Answer option 2 description"
                        }],
                      allowSkip: true
                  }
                  break;
              case "singleq":
                  toReturn = {
                      type: "singleq",
                      questionID: getQuestionID(),
                      content: {
                        ask: "[New single choice question]",
                          heading: false,
                          additionalText: false,
                          tips: false
                      },
                      showTo: {
                          ratingScale: 'all'
                      },
                      answerOptions: [{
                        text: "Answer option 1",
                        description: "Answer option 1 description"
                      },{
                        text: "Answer option 2",
                        description: "Answer option 2 description"
                        }                        
                      ],
                      allowSkip: true
                  }
                  break;
              case "testimonial":
                  toReturn = {
                      type: "testimonial",
                      questionID: "TESTIMONIAL",
                      allowSkip: true,
                      customSkipText: generateTextField(language, 'skip'),
                      content: {
                          ask: generateTextField(language, 'testimonialSecondary'),
                          heading: generateTextField(language, 'testimonialAsk'),
                          additionalText: false,
                          tips: false
                      },
                      videoIncentiveText: false,
                      textInputPlaceholderText: generateTextField(language, 'openTextAnswerPlaceholder'),
                      videoNotesPlaceholderText: generateTextField(language, 'videoMakeNotes'),
                      allowedResponses: {
                          text: true,
                          video: true
                      },
                      showTo: {
                          ratingScale: {
                              high: ratingType === 'nps' ? 10 : 5,
                              low: ratingType === 'nps' ? 7 : 4
                          }
                      },
                      infoToCollect: {
                          company: false,
                          jobTitle: false,
                          profilePicture: true
                      },
                      showIfSkip: false
                  }
                  break;
              case "welcome":
                  toReturn = {
                      type: "welcome",
                      heading: generateTextField(language, 'welcome'),
                      buttonText: generateTextField(language, 'welcomeButtonText'),
                      introParagraph: generateTextField(language, 'welcomeSecondary'),
                      instructions: generateTextField(language, 'welcomeInstructions'),
                      videoIncentiveText: false, //generateTextField(language, 'welcomeSubmitVideo')
                      representative: false,
                      videoURL: false,
                      questionID: "WELCOME",
                      hideFromEmailEntrance: false,
                      customRewardWelcome: false
                  }
                  break;
              case "thankyou":
                  toReturn = {
                      type: "thankyou",
                      questionID: "THANKYOU",
                      content: {
                          ask: generateTextField(language, 'thankYouSecondary'),
                          heading: generateTextField(language, 'thankYouThanks'),
                          additionalText: "",
                          tips: false
                      },
                      externalLinks: [],
                      showTo: {
                          ratingScale: 'all',
                      },
                      thankYouInfo: false
                  }
                  break;
              case "shareq":
                  toReturn = {
                      type: "shareq",
                      questionID: "SHARE",
                      content: {
                          ask: generateTextField(language, 'askShare'),
                          heading: false,
                          additionalText: generateTextField(language, 'askShareSecondary'),
                          tips: false
                      },
                      showTo: {
                          //review gating off by default — every respondent may be asked to
                          //review, regardless of rating (review-gating violates Google policy)
                          ratingScale: 'all'
                      },
                      allowSkip: true,
                      customSkipText: generateTextField(language, 'skip'),
                      shareActions: []
                  }
                  break;
              case "referralq":
                  toReturn = {
                      type: "referralq",
                      questionID: 'REFERRAL', //incase dash wants to filter on it
                      content: {
                          //translated like every other step's defaults (the English text is
                          //frozen into the flow doc at add time, so it must be per-language here)
                          ask: generateTextField(language, 'referralStepAsk'),
                          heading: generateTextField(language, 'referralStepHeading'),
                          additionalText: false,
                          tips: false
                      },
                      showTo: {
                          ratingScale: {
                              high: ratingType === 'nps' ? 10 : 5,
                              low: ratingType === 'nps' ? 7 : 4
                          }
                      },
                      allowSkip: true,
                      //ordered share-channel buttons; the survey app hides device-dependent
                      //entries at runtime (native needs navigator.share, sms needs a phone)
                      shareMethods: [
                          { methodCode: 'native' },
                          { methodCode: 'sms' },
                          { methodCode: 'whatsapp' },
                          { methodCode: 'facebook' },
                          { methodCode: 'x' },
                          { methodCode: 'email' },
                          { methodCode: 'copy' }
                      ]
                  }
                  break;
              case "contactq":
                  toReturn = {
                      type: "contactq",
                      questionID: 'CONTACT', //incase dash wants to filter on it
                      content: {
                          ask: generateTextField(language, 'contactAsk'),
                          heading: false,
                          additionalText: false,
                          tips: [
                              {
                                  picSource: 'check',
                                  text: generateTextField(language, 'useInfoOnly')
                              }
                          ]
                      },
                      askForAdditional: {
                          company: true,
                          jobTitle: true,
                          profilePicture: false,
                          mobile: false,
                          email: true
                      },
                      showTo: {
                          ratingScale: 'all'
                      },
                      allowSkip: true
                  }
                  break;
          }
          toReturn.uniqueID = getQuestionID()
          return toReturn
      }
      
      toExport.NPSRating = class NPSRating extends Rating {
      
          constructor(rating) {
            super()
            this.rating = rating
          }
        
          get inFive() {
            return this.lookupTable.NPSToFive[this.rating]
          }
        
          get inStar() {
            return this.lookupTable.NPSToFive[this.rating]
          }
        
        }

      toExport.FiveRating = class FiveRating extends Rating {
      
          constructor(rating) {
            super()
            this.rating = rating
          }
        
          get inFive() {
            return this.rating
          }
        
          get inNPS() {
            return this.lookupTable.fiveToNPS[this.rating]
          }
        
        }    



        toExport.decode = function (fieldValue) {    
            if (!fieldValue) return false
            if (fieldValue.indexOf('__fbloflang__') === -1) return false       
            return {
                slug: fieldValue.substring(17),
                languagePackSlug: fieldValue.substring(13,15)
            }
        }
        
        toExport.encode = function(langPackSlug, slug) {
            return '__fbloflang__' + langPackSlug + '__' + slug
        }

        
module.exports = toExport;


